/**
 * 课程路由模块
 * 包含课程列表、详情、订单等页面
 */

const children = [
  {
    path: 'list',
    name: 'course_list',
    url: '/course/list',
    meta: { title: '课程列表', requiresAuth: false },
    component: () => import(/* webpackChunkName: "course" */ '@/views/course/list.vue')
  },
  {
    path: 'detail/:id',
    name: 'course_detail',
    url: '/course/detail',
    meta: { title: '课程详情', requiresAuth: false },
    component: () => import(/* webpackChunkName: "course" */ '@/views/course/detail.vue')
  },
  {
    path: 'my-orders',
    name: 'course_my_orders',
    url: '/course/my_orders',
    meta: { title: '我的课程订单', requiresAuth: true },
    component: () => import(/* webpackChunkName: "course" */ '@/views/course/my_orders.vue')
  }
];

export default {
  path: '/course',
  name: 'course',
  meta: { title: '课程中心' },
  component: () => import('@/layout/user.vue'),
  children: children
};
